import services from '../services/api';

// Painel administrativo: sessao no cookie sr_admin (HttpOnly), separada da de
// cliente e oficina. O front nunca le nem guarda token.
const api = services.apiV1;

export const ROLE_LABEL = {
  support_readonly: 'Suporte (leitura)',
  support_agent: 'Suporte',
  super_admin: 'Administrador',
};

const LEVEL = { support_readonly: 1, support_agent: 2, super_admin: 3 };
export const can = (admin, role) => Boolean(admin) && (LEVEL[admin.role] || 0) >= LEVEL[role];

export const errorMessage = (err, fallback) =>
  (err && err.response && err.response.data && err.response.data.message) || fallback;

const data = (promise) => promise.then((response) => response.data);

export const adminApi = {
  login: (email, password) => data(api.post('admin/login', { email, password })),
  verify: (challengeId, code) => data(api.post('admin/login/verify', { challengeId, code })),
  forgotPassword: (email) => data(api.post('admin/password/forgot', { email })),
  resetPassword: (token, newPassword) => data(api.post('admin/password/reset', { token, newPassword })),
  me: () => data(api.get('admin/me')),
  changePassword: (currentPassword, newPassword) => data(api.post('admin/password', { currentPassword, newPassword })),
  logout: () => data(api.post('admin/logout')),

  listUsers: ({ page, pageSize, sort } = {}) => data(api.get('admin/users', { params: { page, pageSize, sort } })),
  searchUsers: (q) => data(api.get('admin/users', { params: { q } })),
  user: (id) => data(api.get(`admin/users/${id}`)),
  userReveal: (id, reason) => data(api.post(`admin/users/${id}/reveal`, { reason })),
  userViewAs: (id, reason) => data(api.post(`admin/users/${id}/view-as`, { reason })),
  userResetLink: (id) => data(api.post(`admin/users/${id}/reset-link`)),
  userTemporaryPassword: (id, reason, adminPassword) =>
    data(api.post(`admin/users/${id}/temporary-password`, { reason, adminPassword })),

  searchCompanies: (q) => data(api.get('admin/companies', { params: { q } })),
  company: (cnpj) => data(api.get(`admin/companies/${cnpj}`)),
  companyReveal: (cnpj, reason) => data(api.post(`admin/companies/${cnpj}/reveal`, { reason })),
  companyResetLink: (cnpj) => data(api.post(`admin/companies/${cnpj}/reset-link`)),
  companyTemporaryPassword: (cnpj, reason, adminPassword) =>
    data(api.post(`admin/companies/${cnpj}/temporary-password`, { reason, adminPassword })),

  listVehicles: ({ page, pageSize } = {}) => data(api.get('admin/vehicles', { params: { page, pageSize } })),
  searchMaintenances: (plate) => data(api.get('admin/maintenances', { params: { plate } })),
  maintenanceCustomer: (plate, key, reason) => data(api.post('admin/maintenances/customer', { plate, key, reason })),
  maintenanceItems: (params) => data(api.get('admin/maintenances/items', { params })),

  audit: (params) => data(api.get('admin/audit', { params })),
};
